import { useMutation } from '@tanstack/react-query';
import { validateVerificationCode } from '../../infrastructure/api/invitation.api.repository';

export function useValidateVerificationCode() {
  const mutation = useMutation({
    mutationFn: ({ token, code }: { token: string; code: string }) =>
      validateVerificationCode(token, code),
  });

  return {
    validateCode: mutation.mutate,
    validateCodeAsync: mutation.mutateAsync,
    isValidating: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
}
